import React from 'react';
import { ReactComponent as ReferralGroupIcon } from '../../assets/icons/referralGroup.svg';
import { Container, ContentContainer, Row, Text, Title, TitleContainer } from './ReferralInfo.styles';

const ReferralInfo = () => {
  return (
    <Container>
      <Row>
        <ReferralGroupIcon />
        <ContentContainer>
          <TitleContainer>
            <Title>Direct Invites</Title>
          </TitleContainer>
          <Text>
            You earn 3.0% of the gross earnings from creators you directly invite, without impacting their earnings.
          </Text>
        </ContentContainer>
      </Row>
    </Container>
  );
};

export default ReferralInfo;
